import { OptionItem } from 'models';

export const CHILD_EXPERIENCE: OptionItem[] = [
  {
    id: 'All Ages',
    name: 'All Ages',
  },
  {
    id: '0 - 1 months',
    name: '0 - 1 months',
  },
  {
    id: '2 - 12 months',
    name: '2 - 12 months',
  },
  {
    id: '1 - 3 years old',
    name: '1 - 3 years old',
  },
  {
    id: '4 - 6 years old',
    name: '4 - 6 years old',
  },
  {
    id: '7 - 12 years old',
    name: '7 - 12 years old',
  },
  {
    id: '13+ years old',
    name: '13+ years old',
  },
];

export const PETS: OptionItem[] = [
  {
    id: 'Cats',
    name: 'Cats',
  },
  {
    id: 'Dogs',
    name: 'Dogs',
  },
  {
    id: 'All pets',
    name: 'All pets',
  },
];
